import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";
import { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
    lineHeight = "lineHeight",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
        [fields.lineHeight]: string;
    };
}

type Props = WidgetProps;

const HorizontalLine: React.FC<Props> = ({ fields }) => {
    const wrapperStyles = {
        css: css`
            background-color: ${fields.backgroundColor};
            height: ${fields.lineHeight}px;
        `,
    };

    return <StyledWrapper {...wrapperStyles}></StyledWrapper>;
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const horizontalline: WidgetModule = {
    component: HorizontalLine,
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.lineHeight,
                editorTemplate: "IntegerField",
                defaultValue: 5,
                tab: basicTab,
            },
            {
                fieldType: "General",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
            },
        ],
    },
};

export default horizontalline;
